"use client";

import { useEffect } from "react";
import { getUTMParamsFromURL, getUTMDataFromCookies, fetchIPAddress, getUserAgent, type UTMParams } from "@/lib/utm-utils";
import { setCookie } from "@/lib/cookie-utils";

/**
 * Extract UTM parameters from current URL
 * @deprecated Use getUTMParamsFromURL from @/lib/utm-utils instead
 */
export const get_UTM_URLParams = getUTMParamsFromURL;

export const UTMCookieHandler = () => {
  useEffect(() => {
    const storeUTMData = async () => {
      // Get UTM parameters from URL (this now always includes targetUrl)
      // This will capture 'ip' if it's in the URL query params
      const utmParams = getUTMParamsFromURL();

      // Always proceed to store targetUrl, even if no other UTM parameters exist
      // Get existing UTM data from cookies
      const existingUTMData = getUTMDataFromCookies();
      
      // Priority: URL param > existing cookie > fetch new IP
      // Only fetch if IP is not in URL params and not in existing cookie
      if (!utmParams.ip && !existingUTMData.ip) {
        const fetchedIP = await fetchIPAddress();
        if (fetchedIP) {
          utmParams.ip = fetchedIP;
        }
      }
      
      // Always capture current user agent (it's available directly, no API call needed)
      // User agent can change if user switches devices/browsers, so always update it
      const userAgent = getUserAgent();
      if (userAgent) {
        utmParams.userAgent = userAgent;
      }
      
      // Merge new UTM parameters with existing ones (new ones take precedence)
      // Always ensure targetUrl is set to current URL
      const mergedUTMData: UTMParams = { 
        ...existingUTMData, 
        ...utmParams,
        targetUrl: window.location.href, // Always use current URL
        // Ensure user agent is always current (overwrite if exists)
        ...(userAgent && { userAgent })
      };

      // Store as JSON string in cookie (expires in 30 days)
      setCookie("utm_data", JSON.stringify(mergedUTMData), 30);

      // Also store individual UTM parameters as separate cookies for easy access
      Object.entries(mergedUTMData).forEach(([key, value]) => {
        if (value) {
          setCookie(key, value, 30);
        }
      });

      // Store timestamp of when UTM data was captured
      setCookie("utm_timestamp", new Date().toISOString(), 30);

      console.log("UTM parameters stored in cookies:", mergedUTMData);
    };

    storeUTMData();
  }, []);

  // This component doesn't render anything
  return null;
};

export default UTMCookieHandler;
